import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, DrawSVGPlugin);

document.addEventListener("DOMContentLoaded", (event) => {
	const pulses = gsap
		.timeline({
			ease: "elastic(2.5, 1)",
		})
		.from(
			".title-1",
			{
				color: "#59656C",
			},
			0.1
		)
		.from(
			".title-2",
			{
				color: "#59656C",
			},
			0.75
		)
		.from(
			".title-3",
			{
				color: "#59656C",
			},
			1.75
		)
		.from(
			".title-4",
			{
				color: "#59656C",
			},
			2.35
		)
		.from(
			".title-5",
			{
				color: "#59656C",
			},
			3.2
		);

	// Add optional titles if they exist
	if (document.querySelector(".title-6")) {
		pulses.from(
			".title-6",
			{
				color: "#59656C",
			},
			3.2
		);
	}

	if (document.querySelector(".title-7")) {
		pulses.from(
			".title-7",
			{
				color: "#59656C",
			},
			3.2
		);
	}

	gsap.timeline({
			scrollTrigger: {
				trigger: ".scroll-section",
				scrub: 0.3,
				start: "top 50%",
				end: "bottom center"
			},
		})
		.from(".the-line", { drawSVG: 0, duration: 3.5, ease: "linear" }, 0)
		.add(pulses, 0);

	gsap.timeline({
			scrollTrigger: {
				trigger: ".animated-line-mobile",
				start: "top 60%",
				end: "bottom 60%",
				scrub: 0.3,
			},
		})
		.from(".m-the-line", { drawSVG: 0, duration: 4, ease: "linear" }, 0);
});
